module.exports = __webpack_public_path__ + "img/enroll_logo.326013c2.svg";